export default "__VITE_ASSET__65b8fb77__"